import { useMutation } from "@apollo/client";

import {
  AddProductUnitMutation,
  AddProductUnitMutationVariables,
} from "../../../API";
import { ADD_PRODUCT_UNIT } from "../../../common/operations/mutations";
import { handleApolloError } from "../../../common/utils/handleApolloError";

export const useAddProductUnit = () => {
  const [addProductUnitMutation, { loading }] = useMutation<
    AddProductUnitMutation,
    AddProductUnitMutationVariables
  >(ADD_PRODUCT_UNIT, { onError: handleApolloError });

  const addProductUnit = (input: AddProductUnitMutationVariables["input"]) =>
    addProductUnitMutation({ variables: { input } });

  return { addProductUnit, loading };
};
